import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { zustandStorageMiddleware } from "@/infrastructure/storage/zustandStorageMiddleware";

type AuthState = {
    token: string | null;
    roles: string[];
    lastPath: string;

    setToken: (token: string) => void;
    setRoles: (roles: string[]) => void;
    setLastPath: (path: string) => void;
    clearAuth: () => void;
    isAuthenticated: () => boolean;
};

export const useAuthStore = create<AuthState>()(
    persist(
        (set, get) => ({
            token: null,
            roles: [],
            lastPath: "/",

            setToken: (token) => set({ token }),

            setRoles: (roles) => set({ roles }),

            setLastPath: (path) => set({ lastPath: path }),

            clearAuth: () => set({
                token: null,
                roles: [],
                lastPath: "/",
            }),

            isAuthenticated: () => !!get().token,
        }),
        {
            name: 'auth-storage',
            storage: zustandStorageMiddleware,
            partialize: (state) => ({
                token: state.token,
                roles: state.roles,
                lastPath: state.lastPath,
            }),
        }
    )
);